import { render, staticRenderFns } from "./WhatsappOptions.vue?vue&type=template&id=03127b03"
import script from "./WhatsappOptions.vue?vue&type=script&lang=js"
export * from "./WhatsappOptions.vue?vue&type=script&lang=js"
import style0 from "./WhatsappOptions.vue?vue&type=style&index=0&id=03127b03&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports